import StoreTable from "../../storeManager/StoreTable";
import DefaultMainPage from "../../../pages/DefaultMainPage";
import MiniGameManager from "./MiniGameManager";
import CharacterPackage from "./CharacterPackage";
import {productType} from "../../../shared/utils/enum";

const characterPackageMenuItems = [
    {path: "/characterPackage", component: <CharacterPackage/>, label: '캐릭터 패키지'},
    {path: "/characterPackage/table", component: <StoreTable filters={{productType: [productType.CHARACTER_PACKAGE]}}/>, label: '상점 테이블'},
    {path: "/characterPackage/miniGame", component: <MiniGameManager />, label: '미니게임 매니저'},
];

export const characterPackageRoutes = {
    path: "/characterPackage",
    component: <DefaultMainPage buttons={characterPackageMenuItems}/>,

    children: characterPackageMenuItems
}